export default __webpack_public_path__ + "static/media/football.ccd99b8e.svg";